import { ComponentProps } from "react";
import { cn } from "../../../../utils/tailwindMerger.ts";
import  ContentWrapper  from "../../layouts/content-wrapper/ContentWrapper.tsx";
import workrightFragomen from "../../../../assets/images/workrightFragomen.png"

type WreeFooterProps = {
    className?: string;
    withWorkRightLogo?: boolean;
} & ComponentProps<"div">;

const Footer = ({
                        className,
                        withWorkRightLogo,
                        ...props
                    }: WreeFooterProps) => {
    return (
        <footer
            className={cn(
                "w-full h-full flex flex-col md:justify-end  bg-neutral py-4 max-sm:py-4 rounded-xl",
                className,
            )}
            style={{
                boxShadow: "0px 0px 0px 0.2px rgb(0 0 0 / 0.2)",
                ...props.style,
            }}
            {...props}
        >
            <ContentWrapper className="flex md:justify-end justify-center ">
                <div className="flex items-end">
                    <div className="flex h-full flex-col items-end">
                        <div className=" w-full max-sm:text-sm text-xs font-semibold text-gray-500">
                            <span>Powered by</span>
                        </div>
                        {/* destkop image */}
                        <div className="flex max-sm:hidden h-full">
                            <img
                                width={130}
                                src="http://cdn.mcauto-images-production.sendgrid.net/d8b28b6deb031932/b5e2f4f3-bea1-490a-a675-d9451c36185f/200x28.gif"
                                alt="WreeFooter"
                            />
                            {withWorkRightLogo && (
                                <div className="w-[1.5px] mx-2 h-full bg-gray-300"></div>
                            )}
                        </div>
                        {/* mobile image */}
                        <div className="max-sm:flex hidden h-full">
                            <img
                                width={100}
                                src="http://cdn.mcauto-images-production.sendgrid.net/d8b28b6deb031932/b5e2f4f3-bea1-490a-a675-d9451c36185f/200x28.gif"
                                alt="WreeFooter"
                            />
                            {withWorkRightLogo && (
                                <div className="w-[1.5px] mx-2 h-full bg-gray-300"></div>
                            )}
                        </div>
                    </div>
                    {/* destkop image */}
                    {withWorkRightLogo && (
                        <div className="md:block hidden">
                            <img
                                width={120}
                                src={workrightFragomen}
                                alt="WreeFooter"
                                className=""
                            />
                        </div>
                    )}
                    {/* mobile image */}

                    {withWorkRightLogo && (
                        <div className="flex md:hidden ">
                            <img
                                width={100}
                                src={workrightFragomen}
                                alt="WreeFooter"
                                className=""
                            />
                        </div>
                    )}
                </div>
            </ContentWrapper>
        </footer>
    );
};

export default Footer;